import Layout from "layouts/DashboardLayout.jsx";
import LayoutDigit from "layouts/DashboardLayoutDigit";

import MyGroceryList from "../views/MyGroceryList";
import PdfDownload from "../components/share/PdfDownload";
import { serverResponse } from "../util/fakeServer";

const indexRoutes = [
  { path: "/myGroceryList/:id", component: MyGroceryList },
  { path: "/pdfDownload/:id", component: PdfDownload },
  {
    path: "/",
    component: serverResponse.config.global_search ? Layout : LayoutDigit
  }
];

export default indexRoutes;
